import { IQuestionData } from '@/api/types'
import { defineStore } from 'pinia'

type IAnswerType = {
  id: number
  myAnswer: string
}

interface AppState {
  showFrame: boolean
  autoSkip: boolean // 自动跳转
  answer: Array<IAnswerType>
  totalQuestionNum: number // 总题数
  fontsize: number
  leftChangeData: IQuestionData[]
  stopOfflineStatus: boolean
  isSubmit: boolean
}

export const useAppStore = defineStore('app', {
  state: (): AppState => ({
    showFrame: true,
    autoSkip: true,
    answer: [],
    totalQuestionNum: 0,
    fontsize: 16,
    leftChangeData: [],
    stopOfflineStatus: false,
    isSubmit: false // 是否点击了交卷
  }),
  getters: {
    getOfflineStatus(): boolean {
      return this.stopOfflineStatus
    },
    getShowFrame(): boolean {
      return this.showFrame
    },
    getAutoSkip(): boolean {
      return this.autoSkip
    },
    getAnswer(): Array<IAnswerType> {
      return this.answer
    },
    getTotalQuestionNum(): number {
      return this.totalQuestionNum
    },
    getFontsize(): number {
      return this.fontsize
    },
    getLeftChangeData(): IQuestionData[] {
      return this.leftChangeData
    },
    getSubmitStatus():boolean {
      return this.isSubmit
    }
  },
  actions: {
    setSubmitStatus(val: boolean) {
       this.isSubmit = val
    },
    setShowFrame(val: boolean) {
      this.showFrame = val
    },
    setShowOffline(val: boolean) {
      this.stopOfflineStatus = val
    },
    setAutoSkip(val: boolean) {
      this.autoSkip = val
    },
    setTotalQuestion(val: number) {
      this.totalQuestionNum = val
    },
    setFontsize(type: number) {
      if (type === 1) {
        if (this.fontsize > 14) {
          this.fontsize -= 1
        }
      }
      if (type === 2) {
        if (this.fontsize < 20) {
          this.fontsize += 1
        }
      }
    },
    setAnswer(param: IAnswerType) {
      const index = this.answer.findIndex((item) => item.id === param.id)
      if (index !== -1) {
        this.answer[index].myAnswer = param.myAnswer
      } else {
        this.answer.push(param)
      }
    },
    setLeftChangeData(data: IQuestionData[]) {
      this.leftChangeData = data
    },
  },
})
